import { render, staticRenderFns } from "./Huddles.vue?vue&type=template&id=4bb11320&"
import script from "./Huddles.vue?vue&type=script&lang=js&"
export * from "./Huddles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports